/**
 * @fileoverview Module for `src/lib/functions/noop.js`.
 */

/**
 * Does nothing and returns undefined, useful as a default empty callback.
 *
 * @returns {undefined} Always undefined.
 */
function noop() {
  return undefined;
}

export default noop;
